export default "__VITE_ASSET__232de670__"